import { render, staticRenderFns } from "./traineePostassessmentReport.vue?vue&type=template&id=2be1703e&scoped=true"
import script from "./traineePostassessmentReport.vue?vue&type=script&lang=js"
export * from "./traineePostassessmentReport.vue?vue&type=script&lang=js"
import style0 from "./traineePostassessmentReport.vue?vue&type=style&index=0&id=2be1703e&prod&scoped=true&lang=css"
import style1 from "./traineePostassessmentReport.vue?vue&type=style&index=1&id=2be1703e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1703e",
  null
  
)

export default component.exports